import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuildingDefault = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.33333 14.25C5.33333 13.6977 4.88562 13.25 4.33333 13.25H3.25225C2.13885 13.25 1.58125 11.9036 2.36855 11.1161L11.1163 2.36612C11.6044 1.87796 12.3956 1.87796 12.8837 2.36612L21.6315 11.1161C22.4187 11.9036 21.8612 13.25 20.7477 13.25H19.6667C19.1144 13.25 18.6667 13.6977 18.6667 14.25V21C18.6667 21.5523 18.219 22 17.6667 22H6.33333C5.78105 22 5.33333 21.5523 5.33333 21V14.25Z",
		stroke: "#8895A7",
		strokeWidth: 2
	})
});
export default SvgBuildingDefault;
